import { render, staticRenderFns } from "./order.vue?vue&type=template&id=f6914798&scoped=true&"
import script from "./order.vue?vue&type=script&lang=babel&"
export * from "./order.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6914798",
  null
  
)

export default component.exports